function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.08496 7.66387H16.9285",
  stroke: "#AAB6D3",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.30029 11.1787C4.30029 10.7645 4.63608 10.4287 5.05029 10.4287H5.05853C5.47274 10.4287 5.80853 10.7645 5.80853 11.1787C5.80853 11.5929 5.47274 11.9287 5.05853 11.9287H5.05029C4.63608 11.9287 4.30029 11.5929 4.30029 11.1787ZM9.004 10.4287C8.58978 10.4287 8.254 10.7645 8.254 11.1787C8.254 11.5929 8.58978 11.9287 9.004 11.9287H9.01223C9.42645 11.9287 9.76223 11.5929 9.76223 11.1787C9.76223 10.7645 9.42645 10.4287 9.01223 10.4287H9.004ZM12.9481 10.4287C12.5339 10.4287 12.1981 10.7645 12.1981 11.1787C12.1981 11.5929 12.5339 11.9287 12.9481 11.9287H12.9563C13.3705 11.9287 13.7063 11.5929 13.7063 11.1787C13.7063 10.7645 13.3705 10.4287 12.9563 10.4287H12.9481ZM12.9481 13.9266C12.5339 13.9266 12.1981 14.2624 12.1981 14.6766C12.1981 15.0908 12.5339 15.4266 12.9481 15.4266H12.9563C13.3705 15.4266 13.7063 15.0908 13.7063 14.6766C13.7063 14.2624 13.3705 13.9266 12.9563 13.9266H12.9481ZM8.254 14.6766C8.254 14.2624 8.58978 13.9266 9.004 13.9266H9.01223C9.42645 13.9266 9.76223 14.2624 9.76223 14.6766C9.76223 15.0908 9.42645 15.4266 9.01223 15.4266H9.004C8.58978 15.4266 8.254 15.0908 8.254 14.6766ZM5.05029 13.9266C4.63608 13.9266 4.30029 14.2624 4.30029 14.6766C4.30029 15.0908 4.63608 15.4266 5.05029 15.4266H5.05853C5.47274 15.4266 5.80853 15.0908 5.80853 14.6766C5.80853 14.2624 5.47274 13.9266 5.05853 13.9266H5.05029Z",
  fill: "#AAB6D3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5953 1V3.9617",
  stroke: "#AAB6D3",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.41466 1V3.9617",
  stroke: "#AAB6D3",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.7673 2.42133H5.24086C2.63046 2.42133 1 3.89367 1 6.60005V14.7447C1 17.4937 2.63046 19 5.24086 19H12.7591C15.3777 19 17 17.5192 17 14.8128V6.60005C17.0082 3.89367 15.386 2.42133 12.7673 2.42133Z",
  stroke: "#AAB6D3",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgCalendarNew = function SvgCalendarNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar_new.a1142b0c.svg";
export { ForwardRef as ReactComponent };